import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-around;
  width: 100%;
  height: fit-content;
  margin: 0 auto;
  padding: 0;
  padding: 0 5rem;
  h3 {
    width: 100%;
    height: 50px;
    border: 0;
    color: gray;
    font-size: 2rem;
  }
`;
